import React, { useState } from 'react';
import { MiniAppToggle } from './MiniAppToggle';
import { MiniAppSelector } from './MiniAppSelector';
import { Plus } from 'lucide-react';
import { useDesignColors } from '../../../hooks/useDesignColors';

export function MiniAppSettings() {
  const [showSelector, setShowSelector] = useState(false);
  const { colors } = useDesignColors();

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-white mb-2">Mini Apps</h2>
        <p className="text-gray-400 mb-6">Configure and manage your chatbot's mini-apps</p>
      </div>
      
      <button
        onClick={() => setShowSelector(true)}
        className="w-full flex items-center justify-center gap-2 px-6 py-4 rounded-xl transition-all hover:opacity-90"
        style={{
          background: `linear-gradient(135deg, ${colors.gradientStart}, ${colors.gradientEnd})`,
          color: '#FFFFFF',
        }}
      >
        <Plus className="w-5 h-5" />
        <span className="font-medium">Add a Mini App</span>
      </button>
      
      <div className="w-full">
        <MiniAppToggle />
      </div>
      
      {/* The MiniAppSelector is rendered conditionally but not nested in the component's DOM structure */}
      {showSelector && (
        <MiniAppSelector 
          isOpen={showSelector}
          onClose={() => setShowSelector(false)}
        />
      )}
    </div>
  );
}